<template>
	<div class="detail">
		<expan-tip
			title="报名须知"
			content="1、暂不支持“取消报名”操作和查看团长审核结果，请到百应商家后台进行相关操作；2、实际已报名的商品，再次报名会提示“报名失败”，可以在“报名失败”列表手动设为已报名；3、由于服务费等原因报名失败的商品，可以在“报名失败”列表找到，并重新报名活动"
		/>
		<Panel :contentPaddingTop="12">
			<breadCrumb class="mb-12" />
			<div class="header flex-row-align-center pt-16 pb-16">
				<div class="yx-color-text-primary font-h1-medium">
					{{ row.activity_name }}
					<span class="yx-color-text-secondary fz-12 ml-12">{{ row.apply_end_time }}截止</span>
				</div>
				<div class="flex-row-align-center line">
					<el-avatar :size="16" v-if="row.institution_avatar" :src="row.institution_avatar"></el-avatar>
					<img class="text_img" v-else :src="genTextImg(row.institution_name)" />
					<span class="ml-6">{{ row.institution_name }}</span>
				</div>
				<div v-if="signUp === '1'" class="fz-13 ml-10 line">
					<span>手机：</span>
					<span>{{ row.phone_num || '-' }}</span>
					<span class="ml-4 mr-4">|</span>
				</div>
				<div v-if="signUp === '1'" class="fz-13">
					<span>微信：</span>
					<span>{{ row.wechat_id || '-' }}</span>
				</div>
			</div>
			<single :row="row" :signUp="signUp"></single>
		</Panel>
		<Panel>
			<el-tabs @tab-click="handleClick" v-model="tabName">
				<el-tab-pane v-for="(item, index) in tableArr" :label="item.label" :name="item.name" :key="index"></el-tab-pane>
			</el-tabs>
			<div class="search">
				<search ref="search" :cate_info="cate_info" :tabName="tabName" @onSubmit="onSubmit"></search>
			</div>
		</Panel>
		<Panel>
			<div class="flex flex-align-center" v-if="tabName === '0'">
				<div class="ml-14 mr-18">
					<el-checkbox @change="checkeFun" v-model="allChecked" :indeterminate="isIndeterminate">当页全选</el-checkbox>
				</div>
				<span class="mr-10 yx-color-text-regular fz-14">
					已选
					<span class="yx-color-primary">{{ selectionArr.length }}</span>
				</span>
				<el-tooltip :disabled="!!selectionArr.length" content="请先勾选商品" placement="top">
					<el-button @click="batchSignUp" style="border: 1px solid #2475ff; color: #2475ff">批量报名商品</el-button>
				</el-tooltip>
				<el-tooltip content="若报名商品一直处于“待同步商品后更新”状态，可点击手动同步" placement="top">
					<dy-goods-async-button ref="goodsAsyncBtn" needAuth :platformId="1" @refresh="refreshList" class="ml-10"></dy-goods-async-button>
				</el-tooltip>
			</div>
			<multi-table
				v-loading="loading"
				element-loading-text="加载中"
				element-loading-background="rgba(255, 255, 255)"
				ref="multiTable"
				:isEmptyObj="isEmptyObj"
				:columns="filterColumns"
				@gePartnerList="gePartnerList"
				:list="list"
				:options="options"
				:total="total"
				:selectionChange="selectionChange"
				:selectable="row=>row.is_allow_apply==1"
			>
				<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
			</multi-table>
		</Panel>

		<!-- 抖音设置团长活动机制 -->
		<setting ref="setting" @refresh="refreshList" />

		<!-- 手动设置已报名 -->
		<confirm ref="confirm" @refreshList="refreshList" />
	</div>
</template>
<script>
import single from '../../components/single.vue';
import { activitySync, activityDetail } from '@/api/secondColonelManage';
import { gen_text_img } from '@/utils/common';
import empty from '@/views/common/empty/index.vue';
import { unApplyProductList, applyProductList } from '@/api/secondColonelManage';
import confirm from './components/confirm.vue';
import setting from './components/setting.vue';
import search from './components/search.vue';
import { columns_success, columns_fail } from './columns';
import dyGoodsAsyncButton from '@/modules/dyAsync/goods';
export default {
	name: 'detail',
	components: {
		single,
		empty,
		confirm,
		setting,
		search,
		dyGoodsAsyncButton,
	},
	data() {
		return {
			tableArr: [
				{ label: '未报名商品', name: '0' },
				{ label: '已报名商品', name: '1' },
				{ label: '报名失败商品', name: '2' },
			],
			row: {},
			tabName: '0',
			signUp: '0',
			cate_info: [],
			sync_type: '4',
			params: {
				page_index: 1,
				page_size: 10,
			},
			list: [],
			options: { selectable: true },
			isEmptyObj: {
				isEmpty: false,
				isEmptyShop: true,
				searchEmpty: false,
				isAuth: true,
			},
			columns_success,
			columns_fail,
			total: '0',
			loading: true,
			isSearch: false,
			selectionArr: [],
			allChecked: false,
			isIndeterminate: false,
		};
	},
	watch: {
		tabName(newVal) {
			this.selectionArr = [];
			this.allChecked = false;
			if (newVal === '0') {
				this.options.selectable = true;
			} else {
				this.options.selectable = false;
			}
		},
		immediate: true,
	},
	created() {
		let signUp = this.$route.query.signUp || '0';
		this.tabName = signUp;
		this.signUp = signUp;
		this.activityDetail();
		this.getProductList();
	},
	computed: {
		activity_id() {
			return this.$route.query.id;
		},
		third_activity_id() {
			return this.$route.query.third_activity_id;
		},
		team_institution_id() {
			const { institution_info = {} } = this;
			return institution_info.team_institution_id || '';
		},
		filterColumns() {
			const { tabName, columns_fail, columns_success } = this;
			return tabName === '2' ? columns_fail : columns_success;
		},
		authorityId() {
			return this.$route.query.authority_id || '';
		},
	},
	methods: {
		batchSignUp() {
			if (!this.selectionArr.length) {
				this.$message.warning('请先选择商品');
				return;
			}
			this.$refs.setting.show(this.selectionArr, this.activity_id, this.authorityId, this.row.commission_rate);
		},
		//选择商品
		selectionChange(val) {
			this.selectionArr = val;
			const selectLength = this.selectionArr.length;
			this.allChecked = selectLength && selectLength === this.list.length;
			this.isIndeterminate = Boolean(selectLength && selectLength < this.list.length);
		},
		checkeFun(val) {
			let allowSelectAllList = this.list.filter(item => item.is_allow_apply === 1)
			this.$refs.multiTable.toggleSelection(allowSelectAllList, val);
		},

		handleClick() {
			this.getProductList();
		},
		async activityDetail() {
			const { activity_id } = this;
			const { code, data } = await activityDetail({ activity_id });
			if (code !== 0) return;
			this.row = data;
			this.cate_info = data.cate_info;
		},
		async updateList() {
			const { third_activity_id, sync_type, authorityId: authority_id } = this;
			const { code } = await activitySync({ item_id: third_activity_id, type: sync_type, authority_id });
			if (code !== 0) return;
			this.$message({
				iconClass: 'el-icon-info primary mr-10',
				message: '商品正在同步...',
			});
		},
		async getProductList(isSearch) {
			const { tabName, authorityId: authority_id } = this;
			this.isSearch = Boolean(isSearch);
			this.loading = true;
			this.tabName = tabName;
			const { activity_id } = this;
			this.params.activity_id = activity_id;
			this.params.authority_id = authority_id;
			if (tabName === '0') {
				const { code, data } = await unApplyProductList(this.params);
				if (code !== 0) return;
				this.list = data.list.map(item => {
					return {
						...item,
						operations: this.getButtons(item),
					};
				});
				this.total = `${data.page.item_total}`;
			} else {
				this.params.apply_status = tabName;
				const { code, data } = await applyProductList(this.params);
				if (code !== 0) return;
				this.list = data.list.map(item => {
					return {
						...item,
						operations: this.getButtons(item),
					};
				});
				this.total = `${data.page.item_total}`;
			}
			this.loading = false;
		},
		//操作按钮
		getButtons(item) {
			const { tabName } = this;
			let arr = [];
			arr.push(
				{
					label: tabName === '0' ? '报名' : '重新报名',
					type: 'text',
					classtype: 2,
					tooltipContent: item.not_allow_desc,
					disabledTooltip: item.is_allow_apply == '0',
					notSelf: item.is_allow_apply == '0',
					isShow: tabName == '0',
					click: row => {
						if (item.is_allow_apply == '0') return;
						this.$refs.setting.show([row], this.activity_id, this.authorityId);
					},
				},
				{
					label: tabName === '1' ? '手动设为未报名' : '手动设为已报名',
					type: 'text',
					classtype: 2,
					tooltipContent: tabName === '1' ? '该操作仅作为标记，不进行取消报名团长活动的操作' : '该操作仅作为标记，不进行重新报名团长活动的操作',
					disabledTooltip: true,
					isShow: tabName !== '0',
					click: row => {
						this.$refs.confirm.show(
							{
								apply_id: row.apply_id,
								apply_status: tabName === '1' ? '2' : '1',
								authority_id: this.authorityId,
							},
							tabName === '1' ? '手动设为未报名' : '手动设为已报名',
						);
					},
				},
			);

			return arr.filter(item => item.isShow);
		},
		genTextImg(name) {
			let str = name ? name.slice(0, 1) : '无';
			return gen_text_img([60, 60], str);
		},
		//筛选
		onSubmit(val) {
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.getProductList(1);
		},
		gePartnerList(val) {
			this.params.page_index = val.page_index;
			this.params.page_size = val.page_size;
			this.getProductList();
		},
		refreshList() {
			this.getProductList();
		}
	},
};
</script>
<style lang="less" scoped>
.header {
	border-top: 1px solid @color-gy3;
	border-bottom: 1px solid @color-gy3;
	.line::before {
		content: '';
		width: 1px;
		height: 12px;
		background-color: @color-gy4;
		margin: 0px 16px;
	}
}
.text_img {
	width: 16px;
	height: 16px;
	border-radius: 50%;
}
</style>
